import {
  CashBreakdown,
  FmsAccountManagement,
  FmsPaymentDetails,
  FmsRecycleStat,
  FmsShopCashLog,
  FmsShopCashSettlement,
} from 'types/fms';
import { ginzaxiaomaApiRequest } from '.';
import { UserInfo } from 'types/user';
import { OrdersSummaryResponse, SysShop } from 'types/sys';

// 现金结算相关类型定义
export interface ShopCashSettlementDto {
  shopId: number;
  beginningCashAmount: number;
  treasuryCashInAmount?: number;
  treasuryCashOutAmount?: number;
  systemCashSales: number;
  expectedCash: number;
  verifiedCashAmount: number;
  varianceAmount: number;
  cashCounter: string;
  note?: string;
  cashBreakdown: CashBreakdown;
  nonCashTotal?: number;
  paymentDetails?: FmsPaymentDetails; // 结算时刻的支付构成明细快照
  recycleStats?: FmsRecycleStat[]; // 回收统计快照
}

export const financialManagementAddOrUpdateAccount = (
  data: FmsAccountManagement,
) => {
  return ginzaxiaomaApiRequest.post(
    '/admin/payment-account/create-or-update',
    data,
  );
};

export const financialManagementAccountList = (storeId?: UserInfo['shop']) => {
  return ginzaxiaomaApiRequest.get<FmsAccountManagement[]>(
    '/admin/payment-account/list',
    {
      params: {
        storeId,
      },
    },
  );
};

export const getShopCashLogList = (dto: {
  shopId: number;
  pageNum: number;
  pageSize: number;
  keyword?: string;
  startDate?: string;
  endDate?: string;
}) => {
  return ginzaxiaomaApiRequest.get<{
    list: FmsShopCashLog[];
    total: number;
  }>('/admin/fms/shop-cash-log/list', {
    params: dto,
  });
};

export const addShopCashLog = (
  data: Pick<FmsShopCashLog, 'shopId' | 'amount' | 'note'>,
) => {
  return ginzaxiaomaApiRequest.post('/admin/fms/shop-cash-log/create', data);
};

export const getSysShopList = () => {
  return ginzaxiaomaApiRequest.get<SysShop[]>('/admin/fms/shop-list');
};

export const getSysSummary = (shopId: number) => {
  return ginzaxiaomaApiRequest.get<OrdersSummaryResponse>(
    `/admin/order/summary/${shopId}`,
  );
};

// 新增：现金结算相关的两个 API 接口

/**
 * 获取今日起始现金金额
 */
export const getTodayBeginningCashAmount = (shopId: number) => {
  return ginzaxiaomaApiRequest.get<number>(
    `/admin/fms/shop-cash-settlement/beginningCashAmount/${shopId}`,
  );
};

/**
 * 创建现金结算记录
 */
export const createShopCashSettlement = (data: ShopCashSettlementDto) => {
  return ginzaxiaomaApiRequest.post(
    '/admin/fms/shop-cash-settlement/create',
    data,
  );
};

/**
 * 获取店铺当日现金流水总和
 */
export const getShopCashSum = (shopId: number) => {
  return ginzaxiaomaApiRequest.get<number>(`/admin/fms/shop-cash-sum/${shopId}`);
};

/**
 * 获取现金结算列表
 */
export const getShopCashSettlementList = (dto: {
  shopId: number;
  pageNum: number;
  pageSize: number;
  settlementStartDate?: string;
  settlementEndDate?: string;
}) => {
  return ginzaxiaomaApiRequest.get<{
    list: FmsShopCashSettlement[];
    total: number;
  }>('/admin/fms/shop-cash-settlement/list', {
    params: dto,
  });
};

export interface NonCashOrderPayment {
  orderId: string;
  payAmount: string;
  payType: string;
  receiptKeys?: string[] | null;
  note?: string | null;
  staffName?: string | null;
  productIds?: string | null;
}

export const getNonCashOrderPayments = (shopId: number) => {
  return ginzaxiaomaApiRequest.get<NonCashOrderPayment[]>(
    `/admin/fms/non-cash-order-payments/${shopId}`,
  );
};

export const getCashOrderPayments = (shopId: number) => {
  return ginzaxiaomaApiRequest.get<NonCashOrderPayment[]>(
    `/admin/fms/cash-order-payments/${shopId}`,
  );
};

/**
 * 查询门店当日现金找零总额（按服务端当日 00:00:00 ~ 23:59:59.999 统计）
 */
export const getDailyCashChange = (shopId: number) => {
  return ginzaxiaomaApiRequest.get<number>(
    `/admin/fms/daily-cash-change/${shopId}`,
  );
};

/**
 * 查询门店当日跨期退款支付记录（付款在上期或更早、退款发生在当日）
 */
export const getRefundOrderPayments = (shopId: number) => {
  return ginzaxiaomaApiRequest.get<NonCashOrderPayment[]>(
    `/admin/fms/refund-order-payments/${shopId}`,
  );
};
